module.exports = __webpack_public_path__ + "img/addTextNum5_2.1a203986.png";